<template>
  <ul class="card-list" :class="{'card-list--pull-up': pullUp}">
    <li class="grid__cell grid__cell--2 card-list__item">
      <div class="card card--big card--no-pointer">
        <h3 class="card__title">
          Magánszemély vagyok
        </h3>

        <strong class="card__description">Hirdesd magad munkakeresőként, vagy keress munkaerőt alkalmi munkákra!</strong>

        <div class="card__buttons">
          <router-link to="/infografika/munkakereso">
            <img src="../../assets/icons/info.svg" class="icon" alt="">
          </router-link>

          <router-link :to="{ path: '/belepes/maganszemely', query: query }" class="btn btn--default btn--double btn--wide">
            Belépek
          </router-link>

          <router-link to="/video/maganszemely">
            <img src="../../assets/icons/play.svg" class="icon" alt="">
          </router-link>
        </div>
      </div>

      <p class="card__button text--center">
        <router-link to="/regisztracio/maganszemely" class="btn btn--primary">
          Regisztrálok magánszemélyként
        </router-link>
      </p>
    </li>

    <li class="grid__cell grid__cell--2 card-list__item">
      <div class="card card--big card--no-pointer">
        <h3 class="card__title">
          Cég vagyok
        </h3>

        <strong class="card__description">Keresd meg a legjobb munkaerőt céged számára, és tedd meg ajánlatod!</strong>

        <div class="card__buttons">
          <router-link to="infografika/munkaado">
            <img src="../../assets/icons/info.svg" class="icon" alt="">
          </router-link>

          <router-link :to="{ path: '/belepes/ceg', query: query }" class="btn btn--default btn--double btn--wide">
            Belépek
          </router-link>

          <router-link to="/video/ceg">
            <img src="../../assets/icons/play.svg" class="icon" alt="">
          </router-link>
        </div>
      </div>

      <p class="card__button text--center">
        <router-link to="/regisztracio/ceg" class="btn btn--primary">
          Regisztrálok cégként
        </router-link>
      </p>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      pullUp: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      query () {
        return this.$route.query
      }
    }
  }
</script>

<style scoped>
.card {
  position: relative;
}

.icon {
  width: 48px;
}
</style>



// WEBPACK FOOTER //
// LoginCards.vue?52387806